export type SortEnquiriesParams = {
    orderBy: null | string;
    desc?: boolean;
};

export function sortByField<T>(elements: T[], fieldName: keyof T | string, desc: boolean = false): T[] {
    return elements.slice().sort((a, b) => {
        let fieldA = typeof fieldName === "string" ? getInnerFieldValue(a, fieldName) : a[fieldName];
        let fieldB = typeof fieldName === "string" ? getInnerFieldValue(b, fieldName) : b[fieldName];
        fieldA = typeof fieldA === "string" ? fieldA.toLocaleLowerCase() : fieldA;
        fieldB = typeof fieldB === "string" ? fieldB.toLocaleLowerCase() : fieldB;
        return desc ? (fieldB > fieldA ? 1 : fieldB < fieldA ? -1 : 0) : fieldB < fieldA ? 1 : fieldB > fieldA ? -1 : 0;
    });
}

export function getInnerFieldValue(obj: any, fieldName: string): any {
    const objKeys = fieldName.split(".");
    let result = obj;

    for (const key of objKeys) {
        if (result === undefined) {
            return undefined;
        }

        if (key.includes("[")) {
            // indexed field
            const [arrayField, index] = key.split("[");
            result = result[arrayField][parseInt(index)];
        } else {
            result = result[key];
        }
    }

    return result;
}
